import ProductCodeSearch from '@components/v2/layout/AppTemplate/components/ProductSearch/ProductCodeSearch';
import Chip from '@components/v2/ui/Chip/Chip';
import { Box } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import OrderBookModal from '../../../../modules/order-book/OrderBookModal';
import OrderActiveMenu from '../../../../modules/order-book/components/OrderActiveMenu/OrderActiveMenu';
import { useTranslation } from '../../../../modules/translation/TranslationContext';
import { useAbility } from '../../../../modules/users/AbilityContext';
import NavigationLogo from '../../components/HomeNavigationHeader/components/NavigationLogo/NavigationLogo';

const OfflineNavigationHeader = () => {
  const { translate } = useTranslation();
  const ability = useAbility();

  const verifyBrandContext = (callback: () => void) => callback();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        gap: (theme) => theme.spacing(1),
        marginLeft: (theme) => theme.spacing(1),
      }}
    >
      <NavigationLogo />
      <Chip
        size="small"
        label={translate(LangEnum.GLOBAL_OFFLINE_MODE)}
        sx={{
          backgroundColor: (theme) => theme.palette.primary.main,
          color: (theme) => theme.palette.primary.contrastText,
          '&:hover': {
            backgroundColor: (theme) => theme.palette.primary.main,
          },
        }}
      />
      <Box
        sx={{
          ml: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: (theme) => theme.spacing(1),
        }}
      >
        {ability.can('read', 'order-items') && (
          <ProductCodeSearch mode="search" verifyBrandContext={verifyBrandContext} />
        )}
        <OrderBookModal />
        <OrderActiveMenu verifyBrandContext={verifyBrandContext} />
      </Box>
    </Box>
  );
};

export default OfflineNavigationHeader;
